import React, { Component, createRef } from 'react'
import { connect } from 'react-redux'
import saveAs from 'file-saver';
import jsPDF from 'jspdf';
import { setVerifyInputFile, setVerifyDSInputFile, clearVerifyInputFile,
		clearVerifyDSInputFile, clearVerifyResultData, clearFileSignedData, setVerifyDSExpand, clearModifiedDSData, setIsLoading, setSignatureDifferenceType, clearSignatureDifferenceType,
		setShowUpgradeCard } from '../../actions/localStates'
import { bindActionCreators } from 'redux'
import { fromBytes } from '../../actions/stringEncodersFuncs'
import i18next from 'i18next'

import '../../fonts/Roboto-Regular-normal.js';
import '../../fonts/Roboto-Regular-bold.js';
import '../../fonts/Roboto-Bold-normal.js';


// import html2pdf from 'html2pdf.js';

import VerifyDSOptionsContainer from '../../containers/VerifyDSOptionsContainer'
import VerifyTextDSContainer from '../../containers/VerifyTextDSContainer'

import QRPopup from './QRPopup'
import PrivateSignPopup from './PrivateSignPopup'

import Dropzone from 'react-dropzone';

const dropzoneRef = createRef();
const dropzoneDSRef = createRef();

function normalizeOid(oid) {
  const baseOids = [
    "1.2.804.2.1.1.1.1.3.6",
  	"1.2.804.2.1.1.1.1.3.1"
  ];

  for (const base of baseOids) {
    if (oid === base || oid.startsWith(base + ".")) {
      return base;
    }
  }

  return oid;
}

class VerifyDSTab extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
	    	isLoading: false,
	    	collapseVerifyDSShow: "",
	    	showPopup: false,
	    	displayedData: null,
	    	showPrivateSignPopup: false
	    }

	    this.showDsVerifyResults = this.showDsVerifyResults.bind(this);
	    this.handleShowQR = this.handleShowQR.bind(this);

	    this.handleOnDrop = this.handleOnDrop.bind(this);
	    this.handleOnDropDS = this.handleOnDropDS.bind(this);

	    this.copyVerifyResults = this.copyVerifyResults.bind(this);
	    this.generateTextResult = this.generateTextResult.bind(this);

	    this.saveVerifyResultsToPdf = this.saveVerifyResultsToPdf.bind(this);
	    this.handleShowPrivateSign = this.handleShowPrivateSign.bind(this);
	}

	handleShowQR (i) {
		var data;
        document.activeElement.blur();

        if (this.state.displayedData === null) {
			data = {
				fileName: this.props.defaultOptionState.signatureType === "attached" ? this.props.defaultState.fileWithDSName : this.props.defaultState.fileInputName,
				qrLink: this.props.defaultState.verifyResultsForQR[i]
			}

			this.setState({
	        	displayedData: data
	        })
		} else {
			this.setState({
	        	displayedData: null
	        })
		}

        this.setState({
            showPopup: !this.state.showPopup
        });
    }

    handleShowPrivateSign (base64Image) {
		var data;
        document.activeElement.blur();

        if (this.state.displayedData === null) {
			data = {
				fileName: this.props.defaultOptionState.signatureType === "attached" ? this.props.defaultState.fileWithDSName : this.props.defaultState.fileInputName,
				privateSignImage: base64Image
			}

			this.setState({
	        	displayedData: data
	        })
		} else {
			this.setState({
	        	displayedData: null
	        })
		}

        this.setState({
            showPrivateSignPopup: !this.state.showPrivateSignPopup
        });
    }

	expandVerifyDS() {
		this.props.actions.setVerifyDSExpand(this.props.expandedCardsReducer.verifyExpanded)
		this.props.expandedCardsReducer.verifyExpanded ? this.setState({collapseVerifyDSShow: "card-body collapse"}) : this.setState({collapseVerifyDSShow: "card-body collapse show"})
	}

	buildFileInputSelector(){
		const fileInputSelector = document.getElementById('fileInputUpload');
		return fileInputSelector;
	}

	buildFileWithDSSelector(){
		const fileWithDSSelector = document.getElementById('fileWithDSUpload');
		return fileWithDSSelector;
	}

	componentDidMount(){
    	var dropFile = document.getElementById('dropFile');
		var dropDS = document.getElementById('dropDS');

    	this.fileInputSelector = this.buildFileInputSelector();
    	this.fileWithDSSelector = this.buildFileWithDSSelector();
    	this.props.expandedCardsReducer.verifyExpanded ? this.setState({collapseVerifyDSShow: "card-body collapse show"}) : this.setState({collapseVerifyDSShow: "card-body collapse"})

    	if (dropFile !== null) {
			dropFile.addEventListener('dragenter', function(event) {
				dropFile.style.border = "2px solid steelblue";
			}, false);

			dropFile.addEventListener('dragover', function(event) {
				dropFile.style.border = "2px solid steelblue";
			}, false);

			dropFile.addEventListener('dragleave', function(event) {
				dropFile.style.border = "";
			}, false);
		}

		if (dropDS !== null) {
			dropDS.addEventListener('dragenter', function(event) {
				dropDS.style.border = "2px solid steelblue";
			}, false);

			dropDS.addEventListener('dragover', function(event) {
				dropDS.style.border = "2px solid steelblue";
			}, false);

			dropDS.addEventListener('dragleave', function(event) {
				dropDS.style.border = "";
			}, false);
		}
	}

	componentDidUpdate(prevProps) {
		var dropFile = document.getElementById('dropFile');
		var dropDS = document.getElementById('dropDS');

		if (prevProps.signatureType !== this.props.defaultOptionState.signatureType) {
			this.fileInputSelector = this.buildFileInputSelector();
		}

		if (this.state.isLoading && (this.props.defaultState.verifyResults || this.props.defaultState.verifyResults === undefined)) {
			this.setState({isLoading: false})
		}

		if (prevProps.fileInputSelected !== this.props.defaultState.fileInputSelected) {
			if (dropFile !== null) {
				dropFile.addEventListener('dragenter', function(event) {
					dropFile.style.border = "2px solid steelblue";
				}, false);

				dropFile.addEventListener('dragover', function(event) {
					dropFile.style.border = "2px solid steelblue";
				}, false);

				dropFile.addEventListener('dragleave', function(event) {
					dropFile.style.border = "";
				}, false);
			}
		}

		if (prevProps.fileWithDSSelected !== this.props.defaultState.fileWithDSSelected) {
			if (dropDS !== null) {
				dropDS.addEventListener('dragenter', function(event) {
					dropDS.style.border = "2px solid steelblue";
				}, false);

				dropDS.addEventListener('dragover', function(event) {
					dropDS.style.border = "2px solid steelblue";
				}, false);

				dropDS.addEventListener('dragleave', function(event) {
					dropDS.style.border = "";
				}, false);
			}
		}
	}

	handleFileInputSelect(e) {
		e.preventDefault();
		this.fileInputSelector.value = null;
	    this.fileInputSelector.click()
	    document.activeElement.blur()
	    this.props.actions.clearVerifyResultData()
	    this.props.actions.clearFileSignedData()
	    this.props.actions.clearModifiedDSData()
	    this.props.actions.clearSignatureDifferenceType()
	}

	handleFileWithDSSelect(e) {
	    e.preventDefault();
	    this.fileWithDSSelector.value = null;
	    this.fileWithDSSelector.click()
	    document.activeElement.blur()
	    this.props.actions.clearVerifyResultData()
	    this.props.actions.clearModifiedDSData()
	    this.props.actions.clearFileSignedData()
	    this.props.actions.clearSignatureDifferenceType()
	}

	onChangeInput(e) {
		if (e.target.files[0] !== undefined && (e.target.files[0].size < 104857600)) {
			this.props.actions.setVerifyInputFile(e.target.files[0])
		}
	}

	handleOnDrop (files) {
		if (files[0] !== undefined && (files[0].size < 104857600)) {
			this.props.actions.setVerifyInputFile(files[0])
		}
	}

	onChangeDS(e) {
		if (e.target.files[0] !== undefined && (e.target.files[0].size < 104857600)) {
			this.props.actions.setVerifyDSInputFile(e.target.files[0])
		}
	}

	handleOnDropDS (files) {
		if (files[0] !== undefined && (files[0].size < 104857600)) {
			this.props.actions.setVerifyDSInputFile(files[0])
		}
	}

	setInputState() {
		this.props.actions.clearVerifyResultData()
		this.props.actions.setIsLoading(true);
		this.props.setInputs()
	}

	cleanUpFileInputSelect(){
		this.props.actions.clearVerifyResultData()
		this.props.actions.clearVerifyInputFile()
		this.props.actions.clearFileSignedData()
		this.props.actions.clearModifiedDSData()
	}

	cleanUpFileWithDSSelect(){
		this.props.actions.clearVerifyResultData()
		this.props.actions.clearVerifyDSInputFile()
		this.props.actions.clearModifiedDSData()
		this.props.actions.clearFileSignedData()
	}

	downloadModifiedData() {
		if (this.props.defaultState.fileInputName.length > 0) {
			saveAs(this.props.upgradeReducer.modifiedDSData, this.props.defaultState.fileInputName + ".p7s")
		} else {
			saveAs(this.props.upgradeReducer.modifiedDSData, this.props.defaultState.fileWithDSName)
		}
	}

	verifyModifiedData () {
		var fileName;

		if (this.props.defaultState.fileInputName.length > 0) {
			fileName = this.props.defaultState.fileInputName + ".p7s"
		} else {
			fileName = this.props.defaultState.fileWithDSName
		}
    	saveAs(this.props.upgradeReducer.modifiedDSData, fileName)

		function blobToFile(blob, fileName, mimeType = blob.type) {
		    return new File([blob], fileName, { type: mimeType });
		}

		const blob = new Blob([this.props.upgradeReducer.modifiedDSData], { type: "application/pkcs7-signature" });
		const file = blobToFile(blob, fileName);

		this.props.actions.setShowUpgradeCard(false)
		this.props.actions.setVerifyDSInputFile(file)
		this.props.actions.setIsLoading(true);
		this.props.setInputs()
	}

	downloadSignedData() {
        function removeTrailingP7sExtensions(filename) {
		  return filename.replace(/(?:\.p7s)+$/, '');
		}

        var dataFileName = removeTrailingP7sExtensions(this.props.defaultState.fileWithDSName)

    	saveAs(this.props.defaultState.fileSignedData, dataFileName)
	}

	cleanUpForm(){
		this.cleanUpFileInputSelect()
		this.cleanUpFileWithDSSelect()
		this.props.actions.clearVerifyResultData()
		this.props.actions.clearFileSignedData()
		this.props.actions.clearSignatureDifferenceType()
	}

	generateTextResult() {
		var strList = "", str = "", isValid;

		const safeDateParse = (inputData, invalidDate) =>
	    Date.parse(inputData) || invalidDate;

		const highestPriorityDate = (inputObject) =>
		    [
		        inputObject.signatureTimestamps.reduce(
		            (a, b) =>
		                Math.min(
		                    safeDateParse(a.dateTime, Number.MAX_SAFE_INTEGER),
		                    safeDateParse(b.dateTime, Number.MAX_SAFE_INTEGER)
		                ),
		            Number.MAX_SAFE_INTEGER
		        ),
		        safeDateParse(
		            inputObject.contentTimestamp.dateTime,
		            Number.MAX_SAFE_INTEGER
		        ),
		        Date.parse(inputObject.signingDateTime),
		    ].filter((a) => a !== Number.MAX_SAFE_INTEGER)[0];
		
		this.props.defaultState.verifyResults
        .sort((first, second) => {
            const firstHash = highestPriorityDate(first);
            const secondHash = highestPriorityDate(second);

            if (firstHash < secondHash) {
                return -1;
            }

            if (firstHash > secondHash) {
                return 1;
            }

            return 0;
        })
        .map(highestPriorityDate)

		for (var i = 0; i < this.props.defaultState.verifyResults.length; i += 1) {
			isValid = this.props.defaultState.verifyResults[i].isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
			str = i18next.t("ds:signature") + (i + 1) + ": " + isValid + "\n"

		    str += (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitle") + "\n" : i18next.t("ds:unqualifiedTitle") + "\n"

			if (this.props.defaultState.verifyResults[i].status === "SUCCESS") {
				str += i18next.t("ds:signer") + this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerFullName.value + "\n"

				if (this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value) {
					str += i18next.t("ds:organizationName") + this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value) {
					str += i18next.t("ds:title") + this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value + "\n"
				}
				
				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value) {
					str += i18next.t("ds:drfou") + this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value + "\n"
				}
				
				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value) {
					str += i18next.t("ds:edrpou") + this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value + "\n"
				}
		        
		        if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value) {
		        	str += i18next.t("ds:eddrun") + this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value + "\n"
		        }
		       	
		       	if (this.props.defaultState.verifyResults[i].signerInfo.certificateSerialNumber.value) {
		       		str += i18next.t("certificateSerialNumberTitle") + this.props.defaultState.verifyResults[i].signerInfo.certificateSerialNumber.value.replace(/\s/g, "") + "\n"
		       	}

		       	if (this.props.defaultState.verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value) {
		       		str += i18next.t("ds:ca") + this.props.defaultState.verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value + "\n"
		       	}

		       	if (this.props.defaultState.verifyResults[i].signingDateTime !== undefined && this.props.defaultState.verifyResults[i].signingDateTime.length > 0) {
		       		str += i18next.t("ds:dsDate") + this.formatDate(this.props.defaultState.verifyResults[i].signingDateTime) + "\n"
		       	}

		       	if (this.props.defaultState.verifyResults[i].contentTimestamp) {
		       		str += this.constructTimestampDetailsText(this.props.defaultState.verifyResults[i].contentTimestamp, "content")
		       	}

		       	if (this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length) {
					for (var j = 0; j < this.props.defaultState.verifyResults[i].signatureTimestamps.length; j += 1) {
						str += this.constructTimestampDetailsText(this.props.defaultState.verifyResults[i].signatureTimestamps[j], "signature")
					}
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp.value.length > 0) {
					var isElectronicStampTitle = this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")
					str += i18next.t("ds:isElectronicStampTitle") + isElectronicStampTitle + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value.length > 0) {
					var qualifiedCertTitle = this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")
					str += i18next.t("ds:qualifiedCertTitle") + qualifiedCertTitle + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value.length > 0) {
					var QSCDTitle = this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")
					str += i18next.t("ds:QSCDTitle") + QSCDTitle + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName) {
					var QSCDTypeTitle = this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value === null ? i18next.t("ds:notDefined") : this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value
					str += i18next.t("ds:QSCDTypeTitle") + QSCDTypeTitle + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signatureType) {
					var signatureType = this.props.defaultState.verifyResults[i].signatureType === null ? i18next.t("ds:notDefined") : this.props.defaultState.verifyResults[i].signatureType
					str += i18next.t("ds:signatureType") + signatureType + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signatureFormat) {
					var signatureFormat = this.props.defaultState.verifyResults[i].signatureFormat === null ? i18next.t("ds:notDefined") : this.props.defaultState.verifyResults[i].signatureFormat
					str += i18next.t("ds:" + signatureFormat) + "\n"
				}

				if (this.props.defaultState.verifyResults[i].signatureAlgorithmOid) {
					str += i18next.t("signatureAlgorithmOid") + i18next.t("ds:" + normalizeOid(this.props.defaultState.verifyResults[i].signatureAlgorithmOid)) + "\n"
		        }

				if (Object.keys(this.props.defaultState.verifyResults[i].contentTimestamp).length === 0 && this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0) {
					str += i18next.t("ds:lawMsgFirstRow") + "\n"
					str += i18next.t("ds:lawMsgSecondRow") + "\n"
					str += i18next.t("ds:lawMsgThirdRow") + "\n"
				}

				// if (this.props.defaultState.verifyResults[i].failureCause !== undefined && this.props.defaultState.verifyResults[i].failureCause.length > 0) {
				// 	str += this.props.defaultState.verifyResults[i].failureCause
				// }
			} else {
				str += this.props.defaultState.verifyResults[i].failureCause
			}

			strList += str + "\n";
		}

		return strList;
	}

	copyVerifyResults() {
		var textArea,
        copy;

	    function isOS() {
	        return navigator.userAgent.match(/ipad|iphone/i);
	    }

	    function createTextArea(text) {
	        textArea = document.createElement('textArea');
	        textArea.value = text;
	        textArea.style.cssText = "position: absolute";
	        textArea.style.cssText = "top: -9999px";
	        document.body.appendChild(textArea);
	    }

	    function selectText() {
	        var range,
	            selection;

	        if (isOS()) {
	            range = document.createRange();
	            range.selectNodeContents(textArea);
	            selection = window.getSelection();
	            selection.removeAllRanges();
	            selection.addRange(range);
	            textArea.setSelectionRange(0, 999999);
	        } else {
	            textArea.select();
	        }
	    }

	    function copyToClipboard() {        
	        document.execCommand('copy');
	        document.body.removeChild(textArea);
	    }

	    copy = function(text) {
	        createTextArea(text);
	        selectText();
	        copyToClipboard();
	        document.getElementById("copyLink").style.color = "green";
	        window.setTimeout(function () {
	        	document.getElementById("copyLink").style.color = "#1a0dab";
	        }, 1500)
		};

		copy(this.generateTextResult());
	}

	saveVerifyResultsToPdf () {
		var isValid, doc = new jsPDF(), dateNow = new Date(), cleaned = "", verticalOffset = 65, needSort = true, archTimestampCounter = 0, dataFileName = "", maxWidth = 120, tempOffset = 0, tempOffsetSecond = 0, wrappedText, failureCauseSplited;
		var img = 'data:image/png;base64, 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'

		const safeDateParse = (inputData, invalidDate) =>
	    Date.parse(inputData) || invalidDate;

	    this.props.defaultState.verifyResults.forEach((element) => {
			if (element.degreeOfNesting !== undefined) {
				needSort = false;
				return;
			}
		})

		const highestPriorityDate = (inputObject) =>
		    [
		        inputObject.signatureTimestamps.reduce(
		            (a, b) =>
		                Math.min(
		                    safeDateParse(a.dateTime, Number.MAX_SAFE_INTEGER),
		                    safeDateParse(b.dateTime, Number.MAX_SAFE_INTEGER)
		                ),
		            Number.MAX_SAFE_INTEGER
		        ),
		        safeDateParse(
		            inputObject.contentTimestamp.dateTime,
		            Number.MAX_SAFE_INTEGER
		        ),
		        Date.parse(inputObject.signingDateTime),
		    ].filter((a) => a !== Number.MAX_SAFE_INTEGER)[0];
		
		if (needSort) {
			this.props.defaultState.verifyResults
	        .sort((first, second) => {
	            const firstHash = highestPriorityDate(first);
	            const secondHash = highestPriorityDate(second);

	            if (firstHash < secondHash) {
	                return -1;
	            }

	            if (firstHash > secondHash) {
	                return 1;
	            }

	            return 0;
	        })
	        .map(highestPriorityDate)
		}

        function footer(){ 
			doc.setFont("Roboto-Regular", 'normal');
   			doc.setFontSize(10);
		    doc.text(198,292, doc.page.toString());
		    doc.page += 1;
		};

		doc.page = 1;

		footer()

		doc.setFont('Roboto-Regular', 'normal');

		// var str = this.generateTextResult();
		
		doc.addImage(img, 'PNG', 10, 5, 40, 22)

		doc.setFontSize(8);
   		doc.text(i18next.t("titlePdf"), 200, 9, {align:'right'});
   		doc.text(i18next.t("streetAdddresPdf"), 200, 12, {align:'right'});
   		doc.text(i18next.t("phonePdf"), 200, 15, {align:'right'});
   		// doc.text("Факс: +38 (044) 483-0322", 200, 23, {align:'right'});
   		doc.textWithLink("E-mail: csk@gp.gov.ua", 200, 23, {align:'right'});
   		doc.textWithLink("Web: ca.gp.gov.ua", 200, 26, {url: 'ca.gp.gov.ua', align:'right'});
   		doc.line(10, 30, 200, 30);

   		doc.setFont('Roboto-Regular', 'bold');
   		doc.setFontSize(18);
   		doc.text(i18next.t("clientTitlePdf"), 105, 40, {align:'center'});

   		doc.text(i18next.t("protocolTitlePdf"), 105, 48, {align:'center'});

   		doc.setFontSize(10);
   		doc.setFont('Roboto-Regular', 'normal');
   		doc.text(i18next.t("verifyTitlePdf"), 105, 53, {align:'center'});

   		doc.setFont("Roboto-Bold", 'normal');
   		doc.setFontSize(10);
   		doc.text(i18next.t("dateTimePdf"), 10, 60);

   		doc.setFont("Roboto-Regular", 'normal');
   		doc.setFontSize(10);
   		doc.text(dateNow.toLocaleString(), this.props.localesReducer.language === "en" ? 34 : 32, 60);

   		doc.setFont("Roboto-Bold", 'normal');
   		doc.setFontSize(10);
   		doc.text(i18next.t("fileNameWithDS"), 10, 66);

   		doc.setFont("Roboto-Regular", 'normal');
   		doc.setFontSize(10);

   		maxWidth = 120;

		wrappedText = doc.splitTextToSize(this.props.defaultState.fileWithDS.name, maxWidth);
		doc.text(wrappedText, this.props.localesReducer.language === "en" ? 40 : 55, 66);

		if (wrappedText.length > 1) {
			tempOffset = 5;
		}
   		// doc.text(this.props.defaultState.fileWithDS.name, 55, 66);

   		doc.setFont("Roboto-Bold", 'normal');
   		doc.setFontSize(10);
   		doc.text(i18next.t("fileSizeWithDS"), 10, 70 + tempOffset);

   		var res, str = "";
		res = this.props.actions.fromBytes(this.props.defaultState.fileWithDS.size);
		str = res.value + " " + i18next.t(res.unit);

   		doc.setFont("Roboto-Regular", 'normal');
   		doc.setFontSize(10);
   		doc.text(str, this.props.localesReducer.language === "en" ? 36 : 56, 70 + tempOffset);

   		var name = this.props.defaultState.fileWithDS.name.lastIndexOf(".") < 2 ? this.props.defaultState.fileWithDS.name : this.props.defaultState.fileWithDS.name.substr(0, this.props.defaultState.fileWithDS.name.lastIndexOf("."));

   		doc.setFont("Roboto-Bold", 'normal');
   		doc.setFontSize(10);

   		doc.text(i18next.t("fileNameWithoutDS"), 10, 74 + tempOffset);

   		doc.setFont("Roboto-Bold", 'normal');
   		doc.setFontSize(10);

   		function hasSingleExtension(filename) {
		    const parts = filename.split(".");

		    return parts.length === 2;
		}

		function removeExtraExtensions(filename) {
            return filename.replace(/^([^\.]+\.[^\.]+)(\..+)*$/, '$0');
        }

        function removeTrailingP7sExtensions(filename) {
		  return filename.replace(/(?:\.p7s)+$/, '');
		}

		function hasAsicExtension(filename) {
		  const ext = filename.split('.').pop().toLowerCase();
		  return ext === 'asics' || ext === 'asice';
		}

   		doc.setFont("Roboto-Regular", 'normal');
   		doc.setFontSize(10);

		// function removeExtraExtensions(filename) {
  //           return filename.replace(/^([^\.]+\.[^\.]+)(\..+)*$/, '$1');
  //       }

  //       var dataFileName = removeExtraExtensions(this.props.defaultState.fileWithDS.name)
  //       doc.text(dataFileName, 55, 74);

  //  		doc.setFont("Roboto-Bold", 'normal');
  //  		doc.setFontSize(10);
  //  		doc.text(i18next.t("fileSizeWithoutDS"), 10, 78);

  //  		if (this.props.defaultState.fileSignedData === null) {
  //  			if (this.props.defaultState.fileInput !== null && this.props.defaultState.fileInput !== undefined) {
  //  				res = this.props.actions.fromBytes(this.props.defaultState.fileInput.size)
  //  			} else {
  //  			 	res = this.props.actions.fromBytes(this.props.defaultState.fileWithDS.size);
  //  			}
  //  		} else {
  //  			res = this.props.actions.fromBytes(this.props.defaultState.fileSignedData.size);
  //  		}

		// str = res.value + " " + i18next.t(res.unit);

  //  		doc.setFont("Roboto-Regular", 'normal');
  //  		doc.setFontSize(10);

  		if (this.props.defaultOptionState.signatureType === "detached") {
			dataFileName = this.props.defaultState.fileInput.name
		} else {
			cleaned = removeTrailingP7sExtensions(this.props.defaultState.fileWithDS.name);
			dataFileName = cleaned
		}

		if (hasAsicExtension(this.props.defaultState.fileWithDS.name)) {
			dataFileName = "-"
		}

		if (this.props.defaultOptionState.signatureType !== "detached" && this.props.defaultState.fileSignedData === null) {
			dataFileName = "-"
		}

		maxWidth = 140;

		wrappedText = doc.splitTextToSize(dataFileName, maxWidth);

		if (wrappedText.length > 1) {
			tempOffsetSecond = 5;
		}
		doc.text(wrappedText, this.props.localesReducer.language === "en" ? 43 : 56, 74 + tempOffset);

		doc.setFont("Roboto-Bold", 'normal');
   		doc.setFontSize(10);
   		doc.text(i18next.t("fileSizeWithoutDS"), 10, 78 + tempOffset + tempOffsetSecond);

   		if (this.props.defaultState.fileSignedData === null) {
   			if (this.props.defaultState.fileInput !== null && this.props.defaultState.fileInput !== undefined) {
   				res = this.props.actions.fromBytes(this.props.defaultState.fileInput.size)
   			} else {
   			 	res = this.props.actions.fromBytes(this.props.defaultState.fileWithDS.size);
   			}
   		} else {
   			res = this.props.actions.fromBytes(this.props.defaultState.fileSignedData.size);
   		}

		str = res.value + " " + i18next.t(res.unit);

		if (hasAsicExtension(this.props.defaultState.fileWithDS.name)) {
			str = "-"
		}

		if (this.props.defaultOptionState.signatureType !== "detached" && this.props.defaultState.fileSignedData === null) {
			str = "-"
		}

   		doc.setFont("Roboto-Regular", 'normal');
   		doc.setFontSize(10);
   		doc.text(str, this.props.localesReducer.language === "en" ? 41 : 58, 78 + tempOffset + tempOffsetSecond);

   		// doc.setFont("Roboto-Bold", 'normal');
   		// doc.setFontSize(10);
   		// doc.text("Результат перевірки підпису: ", 10, 65);

   		// doc.setFont('Roboto-Regular', 'normal');
   		// doc.text("Підпис перевірено успішно.", 61, 65);
   		// doc.text("Цілісність даних підтверджено.", 10, 69);

   		doc.setFontSize(10);
   		// doc.text(10, 78, str);

   		for (var i = 0; i < this.props.defaultState.verifyResults.length; i += 1) {
   			if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
   				archTimestampCounter += 1;
   				isValid = this.props.defaultState.verifyResults[i].isValid ? i18next.t("ds:sheIsValid") : i18next.t("ds:sheIsInvalid")
   			} else {
   				isValid = this.props.defaultState.verifyResults[i].isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
   			}
			// isValid = this.props.defaultState.verifyResults[i].isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
			// str = i18next.t("ds:signature") + (i + 1) + ": " + isValid + "\n"

			if (this.props.defaultState.verifyResults[i].isUntrustedValid) {
				failureCauseSplited = this.props.defaultState.verifyResults[i].failureCause.split('\n')
			}

			if (verticalOffset + 90 > 290) {
				verticalOffset = 10;
				doc.addPage();
				footer()
				doc.setFont('Roboto-Regular', 'normal');

				// var str = this.generateTextResult();
				
				// doc.addImage(img, 'PNG', 10, 5, 40, 22)

				// doc.setFontSize(8);
		  //  		doc.text("Офіс Генерального прокурора", 200, 9, {align:'right'});
		  //  		doc.text("вул. Різницька, 13/15, м. Київ, 01011", 200, 12, {align:'right'});
		  //  		doc.text("Тел.: +38 (044) 200-75-84", 200, 15, {align:'right'});
		  //  		// doc.text("Факс: +38 (044) 483-0322", 200, 23, {align:'right'});
		  //  		doc.textWithLink("E-mail: csk@gp.gov.ua", 200, 23, {align:'right'});
		  //  		doc.textWithLink("Web: ca.gp.gov.ua", 200, 26, {url: 'ca.gp.gov.ua', align:'right'});
		  //  		doc.line(10, 30, 200, 30);

		   		// doc.setFont('Roboto-Regular', 'bold');
		   		// doc.setFontSize(18);
		   		// doc.text("Клієнт Єдиного сервісу криптографічних операцій", 105, 40, {align:'center'});

		   		// doc.text("ПРОТОКОЛ", 105, 48, {align:'center'});

		   		// doc.setFontSize(10);
		   		// doc.setFont('Roboto-Regular', 'normal');
		   		// doc.text("перевірки кваліфікованого електронного підпису", 105, 53, {align:'center'});

		   		// doc.setFont("Roboto-Bold", 'normal');
		   		// doc.setFontSize(10);
		   		// doc.text("Дата та час: ", 10, 60);

		   		// doc.setFont("Roboto-Regular", 'normal');
		   		// doc.setFontSize(10);
		   		// doc.text(dateNow.toLocaleString(), 32, 60);

		   		// doc.setFont("Roboto-Bold", 'normal');
		   		// doc.setFontSize(10);
		   		// doc.text("Результат перевірки підпису: ", 10, 65);

		   		// doc.setFont('Roboto-Regular', 'normal');
		   		// doc.text("Підпис перевірено успішно.", 61, 65);
		   		// doc.text("Цілісність даних підтверджено.", 10, 69);

		   		doc.setFontSize(10);
			}

			if (i === 0) {
				verticalOffset = verticalOffset + 20
			} else {
				verticalOffset = verticalOffset + 8
			}

			if (this.props.defaultState.verifyResults[i].status === "SUCCESS") {

				if (Object.keys(this.props.defaultState.verifyResults[i].contentTimestamp).length === 0 && this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0 && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
					doc.setFont("Roboto-Bold", 'normal');
					doc.setTextColor("red");

					if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
		    			doc.text(i18next.t("ds:ARCHIVE_TIMESTAMP") + ": ", 10, verticalOffset)
					} else {
						doc.text(i18next.t("ds:signature") + ((i + 1) - archTimestampCounter) + (!needSort ? (this.props.defaultState.verifyResults[i].degreeOfNesting !== undefined ? (i18next.t("level") + (parseInt(this.props.defaultState.verifyResults[i].degreeOfNesting, 10) + 1)) : i18next.t("level") + 1) : "") + ": ", 10, verticalOffset);
					}

					if (!needSort) {
						if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 55 : 52, verticalOffset);
						} else {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 50 : 43, verticalOffset);
						}
					} else {
						if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 55 : 52, verticalOffset);
						} else {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 34 : 27, verticalOffset);
						}
					}
					
				} else {
					doc.setFont("Roboto-Bold", 'normal');

					if (this.props.defaultState.verifyResults[i].isValid) {
						doc.setTextColor("green");
					} else {
						doc.setTextColor("red");
					}

					if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
		    			doc.text(i18next.t("ds:ARCHIVE_TIMESTAMP") + ": ", 10, verticalOffset)
					} else {
						doc.text(i18next.t("ds:signature") + ((i + 1) - archTimestampCounter) + (!needSort ? (this.props.defaultState.verifyResults[i].degreeOfNesting !== undefined ? (i18next.t("level") + (parseInt(this.props.defaultState.verifyResults[i].degreeOfNesting, 10) + 1)) : i18next.t("level") + 1) : "") + ": ", 10, verticalOffset);
					}

					if (!needSort) {
						if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 55 : 52, verticalOffset);
						} else {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 50 : 43, verticalOffset);
						}
						
					} else {
						if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 55 : 52, verticalOffset);
						} else {
							doc.text(isValid, this.props.localesReducer.language === "en" ? 34 : 27, verticalOffset);
						}
					}
				}

				verticalOffset = verticalOffset + 5;
				doc.setFont("Roboto-Bold", 'normal');
				doc.setTextColor("black");

				var isQualified
				if (this.props.defaultState.verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
					isQualified = (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitleShe") : i18next.t("ds:unqualifiedTitleShe")
				} else {
					isQualified = (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitle") : i18next.t("ds:unqualifiedTitle")
				}
				// var isQualified = (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitle") : i18next.t("ds:unqualifiedTitle")
				// doc.text(i18next.t("ds:dsTypeTitle") + ": " + isQualified, 10, verticalOffset);
				doc.text(isQualified, 10, verticalOffset);

				if (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP") {
					verticalOffset = verticalOffset + 5;
					doc.setFont("Roboto-Bold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:signer"), 10, verticalOffset);
					doc.setFont("Roboto-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerFullName.value, this.props.localesReducer.language === "en" ? 24 : 33, verticalOffset);
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
					verticalOffset = verticalOffset + 5;
					doc.setFont("Roboto-Bold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:organizationName"), 10, verticalOffset);
					doc.setFont("Roboto-Regular", 'normal');

					wrappedText = doc.splitTextToSize(this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value, 160);
					doc.text([...wrappedText], this.props.localesReducer.language === "en" ? 35 : 33, verticalOffset);

					if (wrappedText.length > 1) {
						verticalOffset = verticalOffset + 4;
					}

					// doc.text(this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value, 33, verticalOffset);
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
					verticalOffset = verticalOffset + 5;
					doc.setFont("Roboto-Bold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:title"), 10, verticalOffset);
					doc.setFont("Roboto-Regular", 'normal');

					wrappedText = doc.splitTextToSize(this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value, 160);
					doc.text([...wrappedText], this.props.localesReducer.language === "en" ? 25 : 27, verticalOffset);

					if (wrappedText.length > 1) {
						verticalOffset = verticalOffset + 4;
					}

					// doc.text(this.props.defaultState.verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value, 27, verticalOffset);
				}
			
				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
					verticalOffset = verticalOffset + 5;
					doc.setFont("Roboto-Bold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:drfou"), 10, verticalOffset);
					doc.setFont("Roboto-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value, this.props.localesReducer.language === "en" ? 25 : 27, verticalOffset);
				}

				if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
					verticalOffset = verticalOffset + 5;
					doc.setFont("Roboto-Bold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:edrpou"), 10, verticalOffset);
					doc.setFont("Roboto-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value, 27, verticalOffset);
				}
		        
		        if (this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
		        	verticalOffset = verticalOffset + 5;
					doc.setFont("Roboto-Bold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:eddrun"), 10, verticalOffset);
					doc.setFont("Roboto-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value, 27, verticalOffset);
		        }
		       	
		       	if (this.props.defaultState.verifyResults[i].signerInfo.certificateSerialNumber.value) {
		       		verticalOffset = verticalOffset + 5;
					doc.setFont("Roboto-Bold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("certificateSerialNumberTitle"), 10, verticalOffset);
					doc.setFont("Roboto-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.certificateSerialNumber.value.replace(/\s/g, ""), this.props.localesReducer.language === "en" ? 67 : 80, verticalOffset);
		       	}

		       	if (this.props.defaultState.verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value) {
		       		verticalOffset = verticalOffset + 5;
					doc.setFont("Roboto-Bold", 'normal');
					doc.setTextColor("black");
					doc.text(i18next.t("ds:ca"), 10, verticalOffset);
					doc.setFont("Roboto-Regular", 'normal');
					doc.text(this.props.defaultState.verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value, this.props.localesReducer.language === "en" ? 20 : 38, verticalOffset);
		       	}

		       	if (this.props.defaultState.verifyResults[i].signingDateTime !== undefined && this.props.defaultState.verifyResults[i].signingDateTime.length > 0 && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
		       		if (Object.keys(this.props.defaultState.verifyResults[i].contentTimestamp).length === 0 && this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0) {
			       		verticalOffset = verticalOffset + 5;
						doc.setFont("Roboto-Bold", 'normal');
						doc.setTextColor("red");
						doc.text(i18next.t("ds:dsDate"), 10, verticalOffset);
						doc.setFont("Roboto-Regular", 'normal');
						doc.text(this.formatDate(this.props.defaultState.verifyResults[i].signingDateTime), this.props.localesReducer.language === "en" ? 34 : 34, verticalOffset);

						verticalOffset = verticalOffset + 5;
						doc.setFont("Roboto-Bold", 'normal');
						doc.setTextColor("red");
						if (this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0) {
							doc.text(i18next.t("dsTs") + ": ", 10, verticalOffset);
							doc.setFont("Roboto-Regular", 'normal');
							doc.text("Відсутня", 70, verticalOffset);
						}
						
					} else {
						verticalOffset = verticalOffset + 5;
						doc.setFont("Roboto-Bold", 'normal');
						doc.setTextColor("black");
						doc.text(i18next.t("ds:dsDate"), 10, verticalOffset);
						doc.setFont("Roboto-Regular", 'normal');
						doc.text(this.formatDate(this.props.defaultState.verifyResults[i].signingDateTime), this.props.localesReducer.language === "en" ? 36 : 34, verticalOffset);
					}
		       	}

		       	if (Object.keys(this.props.defaultState.verifyResults[i].contentTimestamp).length > 0 && this.props.defaultState.verifyResults[i].contentTimestamp) {
		       		verticalOffset = verticalOffset + 5;

					if (this.props.defaultState.verifyResults[i].contentTimestamp && this.props.defaultState.verifyResults[i].contentTimestamp.dateTime) {
			            if (this.props.defaultState.verifyResults[i].contentTimestamp.isFailure) {
			            	doc.setFont("Roboto-Bold", 'normal');
			            	doc.text(i18next.t("dataTs") + ": ", 10, verticalOffset);
			            	doc.setFont("Roboto-Regular", 'normal');
			            	doc.text(i18next.t("ds:errorWhileVerifying"), 75, verticalOffset);
			            } else {
			            	isValid = this.props.defaultState.verifyResults[i].contentTimestamp.isValid ? i18next.t("ds:sheIsValid") : i18next.t("ds:sheIsInvalid")

			            	doc.setFont("Roboto-Bold", 'normal');
			            	doc.setTextColor("green");
			            	doc.text(i18next.t("dataTs") + ": " + isValid + "; ", 10, verticalOffset);
			            	doc.setFont("Roboto-Regular", 'normal');
			            	doc.text(this.formatDate(this.props.defaultState.verifyResults[i].contentTimestamp.dateTime), this.props.localesReducer.language === "en" ? 53 : 80, verticalOffset);

			            	if (this.props.defaultState.verifyResults[i].contentTimestamp.tsaCertificateSerialNumber) {
			            		verticalOffset = verticalOffset + 5;
			            		doc.setTextColor("black");
			            		doc.setFont("Roboto-Bold", 'normal');
				            	doc.text(i18next.t("tsaCertificateSerialNumber"), 10, verticalOffset);
				            	doc.setFont("Roboto-Regular", 'normal');
				            	doc.text(this.props.defaultState.verifyResults[i].contentTimestamp.tsaCertificateSerialNumber, this.props.localesReducer.language === "en" ? 76 : 116, verticalOffset);
			            	}
			            }
			        }
		       	}

		       	if (this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length) {
					for (var j = 0; j < this.props.defaultState.verifyResults[i].signatureTimestamps.length; j += 1) {
						if (this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps[j].dateTime) {
							verticalOffset = verticalOffset + 5;
				            if (this.props.defaultState.verifyResults[i].signatureTimestamps[j].isFailure) {
				            	doc.setFont("Roboto-Bold", 'normal');
				            	doc.text(i18next.t("dataTs") + ": ", 10, verticalOffset);
				            	doc.setFont("Roboto-Regular", 'normal');
				            	doc.text(i18next.t("ds:errorWhileVerifying"), 75, verticalOffset);
				            } else {
				            	isValid = this.props.defaultState.verifyResults[i].signatureTimestamps[j].isValid ? i18next.t("ds:sheIsValid") : i18next.t("ds:sheIsInvalid")

				            	doc.setFont("Roboto-Bold", 'normal');
				            	doc.setTextColor("green");
				            	doc.text(i18next.t("dsTs") + ": " + isValid + "; ", 10, verticalOffset);
				            	doc.setFont("Roboto-Regular", 'normal');
				            	doc.text(this.formatDate(this.props.defaultState.verifyResults[i].signatureTimestamps[j].dateTime), this.props.localesReducer.language === "en" ? 63 : 83, verticalOffset);

				            	if (this.props.defaultState.verifyResults[i].signatureTimestamps[j].tsaCertificateSerialNumber) {
				            		verticalOffset = verticalOffset + 5;
				            		doc.setTextColor("black");
				            		doc.setFont("Roboto-Bold", 'normal');
					            	doc.text(i18next.t("tsaCertificateSerialNumberDS"), 10, verticalOffset);
					            	doc.setFont("Roboto-Regular", 'normal');
					            	doc.text(this.props.defaultState.verifyResults[i].signatureTimestamps[j].tsaCertificateSerialNumber, this.props.localesReducer.language === "en" ? 90 : 112, verticalOffset);
				            	}
				            }
				        }

					}
				}

				if (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP") {
					verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Roboto-Bold", 'normal');
	            	doc.text(i18next.t("ds:isElectronicStampTitle"), 10, verticalOffset);
	            	doc.setFont("Roboto-Regular", 'normal');
	            	doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase"), this.props.localesReducer.language === "en" ? 39 : 46, verticalOffset);
				}

				if (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP") {
					verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Roboto-Bold", 'normal');
	            	doc.text(i18next.t("ds:qualifiedCertTitle"), 10, verticalOffset);
	            	doc.setFont("Roboto-Regular", 'normal');
	            	doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase"), this.props.localesReducer.language === "en" ? 43 : 58, verticalOffset);
				}

				if (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP") {
	            	verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Roboto-Bold", 'normal');
	            	doc.text(i18next.t("ds:QSCDTitle"), 10, verticalOffset);
	            	doc.setFont("Roboto-Regular", 'normal');
	            	doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase"), this.props.localesReducer.language === "en" ? 22 : 29, verticalOffset);
				}

				if (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP") {
	            	verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Roboto-Bold", 'normal');
	            	doc.text(i18next.t("ds:QSCDTypeTitle"), 10, verticalOffset);
	            	doc.setFont("Roboto-Regular", 'normal');
	            	doc.text(this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value === null ? i18next.t("ds:notDefined") : this.props.defaultState.verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value, this.props.localesReducer.language === "en" ? 30 : 38, verticalOffset);
				}

            	if (this.props.defaultState.verifyResults[i].signatureType && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
            		verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Roboto-Bold", 'normal');
	            	doc.text(i18next.t("ds:signatureType"), 10, verticalOffset);
	            	doc.setFont("Roboto-Regular", 'normal');
	            	doc.text(this.props.defaultState.verifyResults[i].signatureType === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + this.props.defaultState.verifyResults[i].signatureType), this.props.localesReducer.language === "en" ? 35 : 39, verticalOffset);
            	}

            	if (this.props.defaultState.verifyResults[i].signatureFormat) {
            		verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Roboto-Bold", 'normal');
	            	doc.text(i18next.t("ds:signatureFormat"), 10, verticalOffset);
	            	doc.setFont("Roboto-Regular", 'normal');
	            	doc.text(this.props.defaultState.verifyResults[i].signatureFormat === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + this.props.defaultState.verifyResults[i].signatureFormat), this.props.localesReducer.language === "en" ? 39 : 39, verticalOffset);
            	}

            	if (this.props.defaultState.verifyResults[i].signatureAlgorithmOid) {
            		verticalOffset = verticalOffset + 5;
					doc.setTextColor("black");
	        		doc.setFont("Roboto-Bold", 'normal');
	            	doc.text(i18next.t("signatureAlgorithmOid"), 10, verticalOffset);
	            	doc.setFont("Roboto-Regular", 'normal');
	            	var normilizedOid = "ds:" + normalizeOid(this.props.defaultState.verifyResults[i].signatureAlgorithmOid)
	            	doc.text(i18next.t(normilizedOid), this.props.localesReducer.language === "en" ? 47 : 44, verticalOffset)
		        }

				if (Object.keys(this.props.defaultState.verifyResults[i].contentTimestamp).length === 0 && this.props.defaultState.verifyResults[i].signatureTimestamps && this.props.defaultState.verifyResults[i].signatureTimestamps.length === 0 && (this.props.defaultState.verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && this.props.defaultState.verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
					verticalOffset = verticalOffset + 10;
            		doc.setTextColor("red");
            		doc.setFont("Roboto-Bold", 'normal');
	            	doc.text(i18next.t("ds:lawMsgFirstRow"), 10, verticalOffset);

	            	verticalOffset = verticalOffset + 10;
            		doc.setTextColor("red");
            		doc.setFont("Roboto-Regular", 'normal');
	            	doc.text(i18next.t("ds:lawMsgSecondRowPDF"), 10, verticalOffset);

	            	verticalOffset = verticalOffset + 5;
            		doc.setTextColor("red");
            		doc.setFont("Roboto-Regular", 'normal');
	            	doc.text(i18next.t("ds:lawMsgThirdRowPDF"), 10, verticalOffset);

	            	verticalOffset = verticalOffset + 5;
            		doc.setTextColor("red");
            		doc.setFont("Roboto-Regular", 'normal');
	            	doc.text(i18next.t("ds:lawMsgFourthRowPDF"), 10, verticalOffset);

	            	verticalOffset = verticalOffset + 10;
            		doc.setTextColor("red");
            		doc.setFont("Roboto-Regular", 'normal');
	            	doc.text(i18next.t("ds:lawMsgFifthRowPDF"), 10, verticalOffset);

	            	verticalOffset = verticalOffset + 5;
            		doc.setTextColor("red");
            		doc.setFont("Roboto-Regular", 'normal');
	            	doc.text(i18next.t("ds:lawMsgSixthRowPDF"), 10, verticalOffset);
				}

			} else {
				doc.setFont("Roboto-Bold", 'normal');
				doc.setTextColor("red");
				doc.text(i18next.t("ds:signature") + (i + 1) + ": ", 10, verticalOffset);
				doc.text(i18next.t("ds:notDefined"), 28, verticalOffset);

				var splitText = doc.splitTextToSize(this.props.defaultState.verifyResults[i].failureCause, 180);
				doc.setFont("Roboto-Regular", 'normal');
				doc.setTextColor("black");

				verticalOffset = verticalOffset + 5;

				for (var c = 0; c < splitText.length; c += 1){
			        doc.text(10, verticalOffset, splitText[c]);
			        verticalOffset = verticalOffset + 5;
			    }
			}
		}

		verticalOffset = verticalOffset + 10;
		doc.setFont("Roboto-Regular", 'normal');
		doc.setTextColor("black");
		doc.text(i18next.t("verifyAddressPdf"), 10, verticalOffset);
		doc.setTextColor("blue");
		doc.textWithLink("caas.gp.gov.ua", 10, verticalOffset + 5, {url: 'caas.gp.gov.ua'});

   		// doc.output("dataurlnewwindow");
   		if (this.props.defaultState.fileInputName.length > 0) {
			doc.save(this.props.defaultState.fileInputName + ".pdf")
		} else {
			doc.save(this.props.defaultState.fileWithDSName + ".pdf")
		}
	}

	formatDate(dateInString) {
        var localeDateOptions = {
            "day": "numeric",
            "month": "numeric",
            "year": "numeric",
            "hour": "2-digit",
            "minute": "2-digit",
            "second": "2-digit",
            "timeZoneName": "short"
        }

        return new Date(dateInString).toLocaleDateString(i18next.language, localeDateOptions);
    }

    constructTimestampDetails(aTs, aTsType) {
        let contentTs = i18next.t("dataTs");
        let signatureTs = i18next.t("dsTs");
        let tsaDS = i18next.t("tsaCertificateSerialNumberDS");
        let tsa = i18next.t("tsaCertificateSerialNumber");
        let result = [];

        let tsTypeString = function () {
            if (aTsType === "content") {
                return contentTs;
            }
            if (aTsType === "signature") {
                return signatureTs;
            }
            return "";
        }

        let tsaTsTypeString = function () {
            if (aTsType === "content") {
                return tsa;
            }
            if (aTsType === "signature") {
                return tsaDS;
            }
            return "";
        }
        
        if (aTs && aTs.dateTime) {
            if (aTs.isFailure) {
                result.push(<div>{tsTypeString() + i18next.t("ds:errorWhileVerifying")}</div>);
            } else {
            	result.push(
	            	<div>
	            		<div>
	            			<span className="font-weight-bold">{tsTypeString()}</span>
	            			{
			            		": "
			                    + (aTs.isValid ? i18next.t("ds:sheIsValid") : i18next.t("ds:sheIsInvalid"))
			                    + "; "
			                    + this.formatDate(aTs.dateTime)
		                	}
		                	{
		                		aTs.tsaCertificateSerialNumber
		                		? <div><span className="font-weight-bold">{tsaTsTypeString()}</span>
				                	{
					                    aTs.tsaCertificateSerialNumber
				                	}
				                </div>
				                : null
		                	}	                	
	            		</div>
	                </div>
                );
            }
        }
        return result;
    }

    constructTimestampDetailsText(aTs, aTsType) {
        let contentTs = i18next.t("dataTs");
        let signatureTs = i18next.t("dsTs");
        let tsaDS = i18next.t("tsaCertificateSerialNumberDS");
        let tsa = i18next.t("tsaCertificateSerialNumber");
        let result = [];

        let tsTypeString = function () {
            if (aTsType === "content") {
                return contentTs;
            }
            if (aTsType === "signature") {
                return signatureTs;
            }
            return "";
        }

        let tsaTsTypeString = function () {
            if (aTsType === "content") {
                return tsa;
            }
            if (aTsType === "signature") {
                return tsaDS;
            }
            return "";
        }
        
        if (aTs && aTs.dateTime) {
            if (aTs.isFailure) {
                result = tsTypeString() + ": " + i18next.t("ds:errorWhileVerifying") + "\n";
            } else {
            	var isValid = aTs.isValid ? i18next.t("ds:sheIsValid") : i18next.t("ds:sheIsInvalid")
            	result = tsTypeString() + ": " + isValid + "; " + this.formatDate(aTs.dateTime) + "\n"

            	if (aTs.tsaCertificateSerialNumber) {
            		result += tsaTsTypeString() + aTs.tsaCertificateSerialNumber + "\n"
            	}
            }
        }
        return result;
    }

	showDsVerifyResults(verifyResults, elementToDisplay, resultType) {
		let rootDiv = [], divPtblg = [], diffType = [], _this = this, needSort = true, isNested = false, archTimestampCounter = 0, failureCauseSplited;
		var generateVerifyResultsViewSimple = generateVerifyResultsViewSimple.bind(this);

		const safeDateParse = (inputData, invalidDate) =>
	    Date.parse(inputData) || invalidDate;

		const highestPriorityDate = (inputObject) =>
		    [
		        inputObject.signatureTimestamps.reduce(
		            (a, b) =>
		                Math.min(
		                    safeDateParse(a.dateTime, Number.MAX_SAFE_INTEGER),
		                    safeDateParse(b.dateTime, Number.MAX_SAFE_INTEGER)
		                ),
		            Number.MAX_SAFE_INTEGER
		        ),
		        safeDateParse(
		            inputObject.contentTimestamp.dateTime,
		            Number.MAX_SAFE_INTEGER
		        ),
		        Date.parse(inputObject.signingDateTime),
		    ].filter((a) => a !== Number.MAX_SAFE_INTEGER)[0];


		verifyResults.forEach((element) => {
			if (element.degreeOfNesting !== undefined) {
				needSort = false;
				isNested = true;
				return;
			}
		})

		if (needSort) {
			verifyResults
	        .sort((first, second) => {
	            const firstHash = highestPriorityDate(first);
	            const secondHash = highestPriorityDate(second);

	            if (firstHash < secondHash) {
	                return -1;
	            }

	            if (firstHash > secondHash) {
	                return 1;
	            }

	            return 0;
	        })
	        .map(highestPriorityDate)
		}

        if (this.props.defaultOptionState.showUpgradeCard) {
        	verifyResults.forEach(function (element) {
	        	_this.props.defaultState.differenceSignatureType.forEach(function (secondElement) {
	        		if (element.signerInfo.certificateSerialNumber !== undefined) {
	        			if (element.signerInfo.certificateSerialNumber.value === secondElement.signerInfo.certificateSerialNumber.value) {
		        			diffType.push(secondElement)
		        		}
	        		}
	        	})
	        })
        }

        function generateVerifyResultsViewSimple (verifyResults) {
        	for (var i = 0; i < verifyResults.length; i += 1) {
	        	let signerNumber = [];
				let signerStatus = [];
				let signerDetails = [];
				let tsDetails = [];
				let tempString = [];

				if (verifyResults[i].isUntrustedValid) {
					failureCauseSplited = verifyResults[i].failureCause.split('\n')
				}

				if (verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP") {
					archTimestampCounter += 1;
				}

				if (verifyResults[i].signatureTimestamps && verifyResults[i].signatureTimestamps.length) {
					for (var j = 0; j < verifyResults[i].signatureTimestamps.length; j += 1) {
						tsDetails.push(this.constructTimestampDetails(verifyResults[i].signatureTimestamps[j], "signature"))
					}
				} else {
					if (!this.props.defaultOptionState.showUpgradeCard && (Object.keys(verifyResults[i].contentTimestamp).length === 0) && (verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP")) {
						tempString.push(<div style={{fontSize: "14px", color: "red"}}>
							<hr style={{marginBottom: "0px", marginTop: "5px"}} />
							<span><p>{i18next.t("ds:lawMsgFirstRow")}</p></span>
							<span><p>{i18next.t("ds:lawMsgSecondRow")}</p></span>
							<span><p>{i18next.t("ds:lawMsgThirdRow")}</p></span>
						</div>);
					}			
				}

				

	        	signerNumber.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
		        	{	
		        		verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP"
		    			? i18next.t("ds:ARCHIVE_TIMESTAMP")
		    			: i18next.t("ds:signature") + ((i + 1) - archTimestampCounter)
		        	}
	        	</div>)

	        	if (verifyResults[i].status === "SUCCESS") {
	        		if (resultType === "verifyResults") {
	        			signerStatus.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{paddingRight: "5px"}}>
		        			{
		        				verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP"
		        				? verifyResults[i].isValid ? i18next.t("ds:sheIsValidUpper") : i18next.t("ds:sheIsInvalidUpper")
		        				: verifyResults[i].isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
		        			}
		        			<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
			        			{
			        				(verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true")
			        				? (verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP" ? i18next.t("ds:qualifiedTitleShe") : i18next.t("ds:qualifiedTitle"))
			        				: (verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP" ? i18next.t("ds:unqualifiedTitleShe") : i18next.t("ds:unqualifiedTitle"))
			        			}
			        		</div>
			        		{
			        			verifyResults[i].failureCause !== null && verifyResults[i].failureCause !== undefined && verifyResults[i].failureCause.length > 0
			        			? <span style={{color: "red"}}>{verifyResults[i].failureCause}</span>
			        			: null
			        		}
		        		</div>)
	        		} else {
	        			signerStatus.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding" style={{paddingRight: "5px"}}>
		        			{
		        				verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP"
		        				? verifyResults[i].isValid ? i18next.t("ds:sheIsValidUpper") : i18next.t("ds:sheIsInvalidUpper")
		        				: verifyResults[i].isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
		        			}
		        			<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
			        			{
			        				(verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true")
			        				? (verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP" ? i18next.t("ds:qualifiedTitleShe") : i18next.t("ds:qualifiedTitle"))
			        				: (verifyResults[i].signatureFormat === "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType === "ARCHIVE_TIMESTAMP" ? i18next.t("ds:unqualifiedTitleShe") : i18next.t("ds:unqualifiedTitle"))
			        			}
			        		</div>
			        		
		        		</div>)
	        		}
			        
			        signerDetails.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signer-details no-left-right-padding">
		    			<div>
		    				{
		    					verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP"
		    					? <div><span className="font-weight-bold">{ i18next.t("ds:signer")}</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerFullName.value }</span></div>
		    					: null
		    				}
		    			</div>
		    				{
								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:organizationName") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value }</span>
					        		</div> : null
					        } {

								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:title") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value }</span>
					        		</div> : null
					        } {
								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:drfou") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value }</span>
					        		</div> : null
					        } {
					        	verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value ? 
						        	<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:edrpou")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value }</span>
					        		</div> : null
					        } {
					        	verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value ? 
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:eddrun")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value }</span>
					        		</div> : null
					        }
		    			<div>
		    				<span className="font-weight-bold">{ i18next.t("ds:ca")}</span><span>{verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value }</span>
		        		</div>
		        		 	{
					        	verifyResults[i].signerInfo.certificateSerialNumber.value ? 
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("certificateSerialNumberTitle")}</span><span>{verifyResults[i].signerInfo.certificateSerialNumber.value.replace(/\s/g, "") }</span>
					        		</div> : null
		                    }
		    			<div>
		    				{
		    					verifyResults[i].signingDateTime !== undefined && verifyResults[i].signingDateTime.length > 0
		    					? <span><span className="font-weight-bold">{ i18next.t("ds:dsDate")}</span><span>{this.formatDate(verifyResults[i].signingDateTime)}</span></span>
		    					: null
		    				}
		    			</div>
		    			<div>
		    				{
		    					this.constructTimestampDetails(verifyResults[i].contentTimestamp, "content")
		    				}
		    			</div>
		    			<div>
		    				{
		    					tsDetails
			                }
		    			</div>
		    			<div>
		    				{
								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:isElectronicStampTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
					        		</div> : null
					        }
		    				{
								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:qualifiedCertTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:QSCDTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:QSCDTypeTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value === null ? i18next.t("ds:notDefined") : verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:signatureType") }</span> <span>{verifyResults[i].signatureType === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + verifyResults[i].signatureType)}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signatureFormat !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureType !== "ARCHIVE_TIMESTAMP" && verifyResults[i].signatureFormat ?
			                        <div>
			                        	{
			                        		verifyResults[i].signatureFormat !== null && verifyResults[i].signatureFormat === "CADES_T" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "false"
			                        		?  <div><span className="font-weight-bold">{ i18next.t("ds:signatureFormat") }</span> <span>{i18next.t("ds:CADES_TU")}</span></div>
			                        		: <div><span className="font-weight-bold">{ i18next.t("ds:signatureFormat") }</span> <span>{verifyResults[i].signatureFormat === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + verifyResults[i].signatureFormat)}</span></div>
			                        	}
					    				
					        		</div> : null
					        }
					        {
					        	verifyResults[i].signatureAlgorithmOid
								? <div>
					    				<span className="font-weight-bold">{ i18next.t("signatureAlgorithmOid") }</span> <span>{i18next.t("ds:" + normalizeOid(verifyResults[i].signatureAlgorithmOid))}</span>
					        		</div>
								: null

					        }
					        {
			        			verifyResults[i].failureCause !== null && verifyResults[i].failureCause !== undefined && verifyResults[i].failureCause.length > 0
			        			? <div style={{marginTop: "10px"}}><span className="font-weight-bold">{verifyResults[i].failureCause}</span></div>
			        			: null
			        		}

			        		{
								verifyResults[i].signerInfo.extensionsCertificateInfo.value.openBankingInfo ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:pspId") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.openBankingInfo.value.pspId.value}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signerInfo.extensionsCertificateInfo.value.openBankingInfo ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:ncaId") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.openBankingInfo.value.ncaId.value}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signerInfo.extensionsCertificateInfo.value.openBankingInfo ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:ncaName") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.openBankingInfo.value.ncaName.value}</span>
					        		</div> : null
					        }
					        {
								verifyResults[i].signerInfo.extensionsCertificateInfo.value.openBankingInfo ?
			                        <div>
					    				<span className="font-weight-bold">{ i18next.t("ds:pspRoles") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.openBankingInfo.value.pspRoles.value}</span>
					        		</div> : null
					        }
		    			</div>
		    		</div>)

		        	divPtblg.push(<div className="ptblg-default" id={"depth"} style={{marginLeft: "-10px", marginRight: "-10px", marginTop: "-10px"}}>
		        		{	
		        			this.props.defaultOptionState.showUpgradeCard && (diffType[i].previousSignatureFormat === "CADES_X_LONG" ? true : false)
				    		? <div className="alert alert-warning">
				        		{i18next.t("ds:alreadyModifiedTitle")}
				        	</div>
				        	: null
		        		}
		        		{
							 <div className={(verifyResults[i].isValid && tempString.length === 0) ? "alert alert-success" : "alert alert-warning"}>
				        		<div className="row">
				        			<div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 no-left-right-padding" style={{paddingLeft: "11px"}}>{signerNumber} {signerStatus}{(verifyResults[i].signatureImageData !== null && verifyResults[i].signatureImageData !== undefined && verifyResults[i].signatureImageData.length > 0 && this.props.base.padesEnabled === "true") ? <div style={{paddingRight: "15px"}}><label className="col-12" style={{paddingLeft: "0px", paddingRight: "0px"}}>{i18next.t("hwsImageLabel")}</label><img style={{maxWidth: "100%", maxHeight: "100%", cursor: "pointer"}} src={"data:image/png;base64," + verifyResults[i].signatureImageData} onClick={this.handleShowPrivateSign.bind(this, verifyResults[i].signatureImageData)} alt="" /></div> : null}{this.props.defaultOptionState.generateQR ? <div><label className="col-12" style={{paddingLeft: "0px", paddingRight: "0px", paddingTop: "10px"}}>{i18next.t("QRSignLabel")}</label><img src={this.props.defaultState.verifyResultsForQR[i]} onClick={this.handleShowQR.bind(this, i)} style={{width: "100px", height: "100px", cursor: "pointer"}} alt="" /></div> : null}</div><div className="col-lg-8 col-md-8 col-sm-12 col-xs-12 no-left-no-right-padding">{signerDetails}</div>
				        		</div>
				        		<div>
					        		{
					        			tempString
					        		}
					        	</div>
				        	</div>
				        }
		        	</div>)
		        } else {
		        	if (verifyResults[i].isUntrustedValid) {
		        		signerStatus.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
		        			{i18next.t("ds:notDefined")}
			        	</div>)
		        		signerDetails.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signer-details no-left-right-padding">
			    			<div>
			    				<span className="font-weight-bold">{ i18next.t("ds:signer")}</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerFullName.value }</span>
			    			</div>
			    				{
									verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:organizationName") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value }</span>
						        		</div> : null
						        } {
									verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:title") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value }</span>
						        		</div> : null
						        } {
									verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:drfou") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value }</span>
						        		</div> : null
						        } {
						        	verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value ? 
							        	<div>
						    				<span className="font-weight-bold">{ i18next.t("ds:edrpou")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value }</span>
						        		</div> : null
						        } {
						        	verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value ? 
						        		<div>
						    				<span className="font-weight-bold">{ i18next.t("ds:eddrun")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value }</span>
						        		</div> : null
						        }
			    			<div>
			    				<span className="font-weight-bold">{ i18next.t("ds:ca")}</span><span>{verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value }</span>
			        		</div>
			        		 	{
						        	verifyResults[i].signerInfo.certificateSerialNumber.value ? 
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("certificateSerialNumberTitle")}</span><span>{verifyResults[i].signerInfo.certificateSerialNumber.value.replace(/\s/g, "") }</span>
						        		</div> : null
			                    }
			    			<div>
			    				{
			    					verifyResults[i].signingDateTime !== undefined && verifyResults[i].signingDateTime.length > 0
			    					? <span><span className="font-weight-bold">{ i18next.t("ds:dsDate")}</span><span>{this.formatDate(verifyResults[i].signingDateTime)}</span></span>
			    					: null
			    				}
			    			</div>
			    			<div>
			    				{
			    					this.constructTimestampDetails(verifyResults[i].contentTimestamp, "content")
			    				}
			    			</div>
			    			<div>
			    				{
			    					tsDetails
				                }
			    			</div>
			    			<div>
			    				{
									verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:isElectronicStampTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isElectronicStamp.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
						        		</div> : null
						        }
			    				{
									verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:qualifiedCertTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
						        		</div> : null
						        }
						        {
									verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:QSCDTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
						        		</div> : null
						        }
						        {
									verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:QSCDTypeTitle") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value === null ? i18next.t("ds:notDefined") : verifyResults[i].signerInfo.extensionsCertificateInfo.value.qscdTypeName.value}</span>
						        		</div> : null
						        }
						        {
									verifyResults[i].signatureType ?
				                        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:signatureType") }</span> <span>{verifyResults[i].signatureType === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + verifyResults[i].signatureType)}</span>
						        		</div> : null
						        }
						        {
									verifyResults[i].signatureFormat ?
				                        <div>
				                        	{
				                        		verifyResults[i].signatureFormat !== null && verifyResults[i].signatureFormat === "CADES_T" && verifyResults[i].signerInfo.extensionsCertificateInfo.value.isQualified.value === "false"
				                        		?  <div><span className="font-weight-bold">{ i18next.t("ds:signatureFormat") }</span> <span>{i18next.t("ds:CADES_TU")}</span></div>
				                        		: <div><span className="font-weight-bold">{ i18next.t("ds:signatureFormat") }</span> <span>{verifyResults[i].signatureFormat === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + verifyResults[i].signatureFormat)}</span></div>
				                        	}
						    				
						        		</div> : null
						        }
						        {
						        	verifyResults[i].signatureAlgorithmOid
									? <div>
						    				<span className="font-weight-bold">{ i18next.t("signatureAlgorithmOid") }</span> <span>{i18next.t("ds:" + normalizeOid(verifyResults[i].signatureAlgorithmOid))}</span>
						        		</div>
									: null

						        }
						        {
						            verifyResults[i].isUntrustedValid
						            ? <div><p></p>
						            	<div>
						            		{
						            			<p><b>{failureCauseSplited[0]}</b></p>
						            		}
						            		
						            		{/*<p style={{"marginBottom": "0.5rem"}}><b>{i18next.t("ds:signatureValidWithUntrustedTime")}</b></p>*/}
						            	</div>
						            </div>
						            : null
						        }
			    			</div>
			    		</div>)
						divPtblg.push(<div className="ptblg-default" id={"depth"} style={{marginLeft: "-10px", marginRight: "-10px", marginTop: "-10px"}}>
			        		<div className={(verifyResults[i].isValid && tempString.length === 0) ? "alert alert-success" : "alert alert-warning"}>
				        		<div className="row">
				        			<div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 no-left-no-right-padding" style={{paddingLeft: "11px"}}>{signerNumber} {signerStatus}</div> <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12 no-left-no-right-padding">{signerDetails}</div>
				        		</div>
				        	</div>
			        	</div>)
		        	} else {
		        		signerStatus.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
		        			{i18next.t("ds:notDefined")}
			        		</div>)
				        signerDetails.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signer-details no-left-right-padding">
				    			<div>
				    				{ verifyResults[i].failureCause }
				    				{
							            verifyResults[i].isUntrustedValid
							            ? <div><p></p><div><b>{i18next.t("ds:signatureValidWithUntrustedTime")}</b></div></div>
							            : null
							        }
				    			</div>
			    			</div>)
			        	divPtblg.push(<div className="ptblg-default" id={"depth"} style={{marginLeft: "-10px", marginRight: "-10px", marginTop: "-10px"}}>
			        		<div className={(verifyResults[i].isValid && tempString.length === 0) ? "alert alert-success" : "alert alert-warning"}>
				        		<div className="row">
				        			<div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 no-left-no-right-padding">{signerNumber} {signerStatus}</div> <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12 no-left-no-right-padding">{signerDetails}</div>
				        		</div>
				        	</div>
			        	</div>)
		        	}
			        
	            }
	        }
        }

		function buildTree(items) {
		  const tree = [];
		  const lastAtLevel = {};

		  items.forEach(item => {
		    const level = item.degreeOfNesting !== undefined
		      ? Number(item.degreeOfNesting)
		      : 0;

		    const node = { ...item, children: [] };

		    if (level === 0) {
		      tree.push(node);
		      lastAtLevel[0] = node;
		    } else {
		      const parent = lastAtLevel[level - 1];
		      if (parent) {
		        parent.children.push(node);
		      } else {
		        console.warn("No parent found for node:", node);
		        tree.push(node); // fallback
		      }
		      lastAtLevel[level] = node;
		    }

		    // очищаємо всі вузли глибше поточного рівня
		    Object.keys(lastAtLevel).forEach(k => {
		      if (Number(k) > level) delete lastAtLevel[k];
		    });
		  });

		  return tree;
		}

		function addIds(items) {
		  return items.map((item, index) => ({
		    ...item,
		    id: index + 1
		  }));
		}

		const updatedData = addIds(verifyResults);

		const tree = buildTree(updatedData);
		archTimestampCounter = 0;
		const TreeNode = ({ node }) => {
			{
				node.signatureFormat === "ARCHIVE_TIMESTAMP" && node.signatureType === "ARCHIVE_TIMESTAMP"
				? archTimestampCounter += 1
				: archTimestampCounter
			}
		  return (
		    <div style={styles.parent}>
		      <div>
		          	{
		          		node.status === "SUCCESS"
		        		? <div className={(node.isValid) ? "alert-last alert-success" : "alert-last alert-warning"}>
		        			
		        			<div className="row">
			        			<div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 no-left-right-padding" style={{paddingLeft: "11px"}}>
				        			<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
				        				{
				        					node.signatureFormat === "ARCHIVE_TIMESTAMP" && node.signatureType === "ARCHIVE_TIMESTAMP"
							    			? i18next.t("ds:ARCHIVE_TIMESTAMP")
							    			: i18next.t("ds:signature") + (node.id - archTimestampCounter)

				        				}
						        	</div>
			        				
			        				{
				        				resultType === "verifyResults"
				        				? <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{paddingRight: "5px"}}>
							        			{	
							        				node.signatureFormat === "ARCHIVE_TIMESTAMP" && node.signatureType === "ARCHIVE_TIMESTAMP"
							        				? node.isValid ? i18next.t("ds:sheIsValidUpper") : i18next.t("ds:sheIsInvalidUpper")
							        				: node.isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
							        			}
							        			<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
								        			{
								        				(node.signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && node.signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitle") : i18next.t("ds:unqualifiedTitle")
								        			}
								        		</div>
								        		{
								        			node.failureCause !== null && node.failureCause !== undefined && node.failureCause.length > 0
								        			? <span style={{color: "red"}}>{node.failureCause}</span>
								        			: null
								        		}
							        		</div>
				        				:   <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding" style={{paddingRight: "5px"}}>
							        			{
							        				node.signatureFormat === "ARCHIVE_TIMESTAMP" && node.signatureType === "ARCHIVE_TIMESTAMP"
							        				? node.isValid ? i18next.t("ds:sheIsValidUpper") : i18next.t("ds:sheIsInvalidUpper")
							        				: node.isValid ? i18next.t("ds:heIsValid") : i18next.t("ds:heIsInvalid")
							        			}
							        			<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
								        			{
								        				(node.signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && node.signerInfo.extensionsCertificateInfo.value.isQualified.value === "true")
								        				? (node.signatureFormat === "ARCHIVE_TIMESTAMP" && node.signatureType === "ARCHIVE_TIMESTAMP" ? i18next.t("ds:qualifiedTitleShe") : i18next.t("ds:qualifiedTitle"))
								        				: (node.signatureFormat === "ARCHIVE_TIMESTAMP" && node.signatureType === "ARCHIVE_TIMESTAMP" ? i18next.t("ds:unqualifiedTitleShe") : i18next.t("ds:unqualifiedTitle"))
								        			}
								        		</div>
								        		{
								        			node.failureCause !== null && node.failureCause !== undefined && node.failureCause.length > 0
								        			? <span style={{color: "red"}}>{node.failureCause}</span>
								        			: null
								        		}
							        		</div>
				        			}

			        				{this.props.defaultOptionState.generateQR
				        				? <img src={this.props.defaultState.verifyResultsForQR[node.id - 1]} onClick={this.handleShowQR.bind(this, node.id - 1)} style={{width: "100px", height: "100px", marginLeft: "15px", cursor: "pointer"}} alt="" />
				        				: null} 
			        			</div> 
				        			<div className="col-lg-8 col-md-8 col-sm-12 col-xs-12 no-left-no-right-padding">
				        				<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signer-details no-left-right-padding">
				        				{
				        					node.signatureFormat !== "ARCHIVE_TIMESTAMP" && node.signatureType !== "ARCHIVE_TIMESTAMP"
				        					? <div>
							    				<span className="font-weight-bold">{ i18next.t("ds:signer")}</span> <span>{node.signerInfo.ownerCertificateInfo.value.ownerFullName.value }</span>
							    			</div> : null
				        				}
					    			
					    				{
											node.signatureFormat !== "ARCHIVE_TIMESTAMP" && node.signatureType !== "ARCHIVE_TIMESTAMP" && node.signerInfo.ownerCertificateInfo.value.ownerOrganization.value ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:organizationName") }</span> <span>{node.signerInfo.ownerCertificateInfo.value.ownerOrganization.value }</span>
								        		</div> : null
								        } {
											node.signatureFormat !== "ARCHIVE_TIMESTAMP" && node.signatureType !== "ARCHIVE_TIMESTAMP" && node.signerInfo.ownerCertificateInfo.value.ownerPosition.value ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:title") }</span> <span>{node.signerInfo.ownerCertificateInfo.value.ownerPosition.value }</span>
								        		</div> : null
								        } {
											node.signatureFormat !== "ARCHIVE_TIMESTAMP" && node.signatureType !== "ARCHIVE_TIMESTAMP" && node.signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:drfou") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value }</span>
								        		</div> : null
								        } {
								        	node.signatureFormat !== "ARCHIVE_TIMESTAMP" && node.signatureType !== "ARCHIVE_TIMESTAMP" && node.signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value ? 
									        	<div>
								    				<span className="font-weight-bold">{ i18next.t("ds:edrpou")}</span><span>{ node.signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value }</span>
								        		</div> : null
								        } {
								        	node.signatureFormat !== "ARCHIVE_TIMESTAMP" && node.signatureType !== "ARCHIVE_TIMESTAMP" && node.signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value ? 
								        		<div>
								    				<span className="font-weight-bold">{ i18next.t("ds:eddrun")}</span><span>{ node.signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value }</span>
								        		</div> : null
								        }
								        <div>
						    				<span className="font-weight-bold">{ i18next.t("ds:ca")}</span><span>{node.signerInfo.issuerCertificateInfo.value.issuerFullName.value }</span>
						        		</div>
					    			
					        		 	{
								        	node.signerInfo.certificateSerialNumber.value ? 
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("certificateSerialNumberTitle")}</span><span>{node.signerInfo.certificateSerialNumber.value.replace(/\s/g, "") }</span>
								        		</div> : null
					                    }
					    			<div>
					    				{
					    					node.signingDateTime !== undefined && node.signingDateTime.length > 0
					    					? <span><span className="font-weight-bold">{ i18next.t("ds:dsDate")}</span><span>{this.formatDate(node.signingDateTime)}</span></span>
					    					: null
					    				}
					    			</div>
					    			<div>
					    				{
					    					this.constructTimestampDetails(node.contentTimestamp, "content")
					    				}
					    			</div>
					    			<div>
					    				{
					    					node.signatureTimestamps.map((element) => (
					    						this.constructTimestampDetails(element, "signature")
					    					))
					    				}
					    				
					    			</div>
					    			<div>
					    				{
											node.signatureFormat !== "ARCHIVE_TIMESTAMP" && node.signatureType !== "ARCHIVE_TIMESTAMP" && node.signerInfo.extensionsCertificateInfo.value.isElectronicStamp ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:isElectronicStampTitle") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.isElectronicStamp.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
								        		</div> : null
								        }
					    				{
											node.signatureFormat !== "ARCHIVE_TIMESTAMP" && node.signatureType !== "ARCHIVE_TIMESTAMP" && node.signerInfo.extensionsCertificateInfo.value.isQualified ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:qualifiedCertTitle") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.isQualified.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
								        		</div> : null
								        }
								        {
											node.signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:QSCDTitle") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")}</span>
								        		</div> : null
								        }
								        {
											node.signerInfo.extensionsCertificateInfo.value.qscdTypeName ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:QSCDTypeTitle") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.qscdTypeName.value === null ? i18next.t("ds:notDefined") : node.signerInfo.extensionsCertificateInfo.value.qscdTypeName.value}</span>
								        		</div> : null
								        }
								        {
											node.signatureFormat !== "ARCHIVE_TIMESTAMP" && node.signatureType !== "ARCHIVE_TIMESTAMP" && node.signatureType ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:signatureType") }</span> <span>{node.signatureType === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + node.signatureType)}</span>
								        		</div> : null
								        }
								        {
											node.signatureFormat !== "ARCHIVE_TIMESTAMP" && node.signatureType !== "ARCHIVE_TIMESTAMP" && node.signatureFormat ?
						                        <div>
						                        	{
						                        		node.signatureFormat !== null && node.signatureFormat === "CADES_T" && node.signerInfo.extensionsCertificateInfo.value.isQualified.value === "false"
						                        		?  <div><span className="font-weight-bold">{ i18next.t("ds:signatureFormat") }</span> <span>{i18next.t("ds:CADES_TU")}</span></div>
						                        		: <div><span className="font-weight-bold">{ i18next.t("ds:signatureFormat") }</span> <span>{node.signatureFormat === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + node.signatureFormat)}</span></div>
						                        	}
								    				
								        		</div> : null
								        }
								        {
								        	node.signatureAlgorithmOid
											? <div>
								    				<span className="font-weight-bold">{ i18next.t("signatureAlgorithmOid") }</span> <span>{i18next.t("ds:" + normalizeOid(node.signatureAlgorithmOid))}</span>
								        		</div>
											: null

								        }
								        {
											node.signerInfo.extensionsCertificateInfo.value.openBankingInfo ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:pspId") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.openBankingInfo.value.pspId.value}</span>
								        		</div> : null
								        }
								        {
											node.signerInfo.extensionsCertificateInfo.value.openBankingInfo ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:ncaId") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.openBankingInfo.value.ncaId.value}</span>
								        		</div> : null
								        }
								        {
											node.signerInfo.extensionsCertificateInfo.value.openBankingInfo ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:ncaName") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.openBankingInfo.value.ncaName.value}</span>
								        		</div> : null
								        }
								        {
											node.signerInfo.extensionsCertificateInfo.value.openBankingInfo ?
						                        <div>
								    				<span className="font-weight-bold">{ i18next.t("ds:pspRoles") }</span> <span>{node.signerInfo.extensionsCertificateInfo.value.openBankingInfo.value.pspRoles.value}</span>
								        		</div> : null
								        }
					    			</div>
					    		</div>
			        			</div>
			        		</div>        			
		        			
		        				
		        		  </div>
		        		: <div>
		        			<div className={(node.isValid) ? "alert-last alert-success" : "alert-last alert-warning"}>
				        		<div className="row">
				        			<div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 no-left-no-right-padding">
				        				<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
							    			{i18next.t("ds:signature") + node.id}
							        	</div>
				        				<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
						        			{i18next.t("ds:notDefined")}
						        		</div>
				        			</div>
				        			<div className="col-lg-9 col-md-9 col-sm-12 col-xs-12 no-left-no-right-padding">
				        				<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signer-details no-left-right-padding">
							    			<div>
							    				{ node.failureCause }
							    				{
										            node.isUntrustedValid
										            ? <div><p></p><div><b>{i18next.t("ds:signatureValidWithUntrustedTime")}</b></div></div>
										            : null
										        }
							    			</div>
						    			</div>
				        			</div>
				        		</div>
				        	</div>
		        		</div>
		          	}
		          
		        </div>
		      {node.children.length > 0 && (
		        <div style={styles.children}>
		          {node.children.map((child, index) => (
		          	node.children.length > 1 && ((index + 1) % 2 === 0)
		          	? <div style={{marginTop: "10px"}}><TreeNode key={child.id} node={child} /></div>
		          	: <TreeNode key={child.id} node={child} />
		          ))}
		        </div>
		      )}
		    </div>
		  );
		};

		const TreeView = ({ data }) => {
			console.log("tree", JSON.stringify(tree, null, 2));
		  return (
		    <div style={styles.tree}>
		      {data.map((node, index) => (
		        <TreeNode key={node.id} node={node} />
		      ))}
		    </div>
		  );
		};

		const styles = {
		  tree: {
		    display: "flex",
		    flexDirection: "column",
		    marginBottom: "10px"
		  },
		  parent: {
		    padding: "10px",
		    border: "1px solid rgba(0, 0, 0, 0.125)",
		    borderRadius: "5px"
		  },
		  node: {
		    padding: "10px",
		    border: "1px solid rgba(0, 0, 0, 0.125)",
		    borderRadius: "5px"
		  },
		  children: {
		    marginTop: "10px"
		  }
		};

		function generateModifyResults (verifyResults) {
			for (var i = 0; i < verifyResults.length; i += 1) {
				let signerNumber = [];
				let signerStatus = [];
				let signerDetails = [];		

	        	signerNumber.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding">
	    			{i18next.t("ds:signature") + (i + 1)}
	        	</div>)
	        		
    			signerStatus.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-left-right-padding" style={{paddingRight: "5px"}}>
        			{
        				verifyResults[i].previousSignatureFormat === verifyResults[i].currentSignatureFormat ? i18next.t("ds:isNotModified") : i18next.t("ds:isModified")
        			}
        		</div>)
		        
		        signerDetails.push(<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signer-details no-left-right-padding">
	    			<div>
	    				<span className="font-weight-bold">{ i18next.t("ds:signer")}</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerFullName.value }</span>
	    			</div>
	    				{
							verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value ?
		                        <div>
				    				<span className="font-weight-bold">{ i18next.t("ds:organizationName") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerOrganization.value }</span>
				        		</div> : null
				        } {
							verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value ?
		                        <div>
				    				<span className="font-weight-bold">{ i18next.t("ds:title") }</span> <span>{verifyResults[i].signerInfo.ownerCertificateInfo.value.ownerPosition.value }</span>
				        		</div> : null
				        } {
							verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value ?
		                        <div>
				    				<span className="font-weight-bold">{ i18next.t("ds:drfou") }</span> <span>{verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value }</span>
				        		</div> : null
				        } {
				        	verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value ? 
					        	<div>
				    				<span className="font-weight-bold">{ i18next.t("ds:edrpou")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value }</span>
				        		</div> : null
				        } {
				        	verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value ? 
				        		<div>
				    				<span className="font-weight-bold">{ i18next.t("ds:eddrun")}</span><span>{ verifyResults[i].signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value }</span>
				        		</div> : null
				        }
	    			<div>
	    				<span className="font-weight-bold">{ i18next.t("ds:ca")}</span><span>{verifyResults[i].signerInfo.issuerCertificateInfo.value.issuerFullName.value }</span>
	        		</div>

	        		{
	        			verifyResults[i].previousSignatureFormat === verifyResults[i].currentSignatureFormat
	        			? <div>
							{
					        	verifyResults[i].currentSignatureType ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:signatureType")}</span><span>{ i18next.t("ds:" + verifyResults[i].currentSignatureType) }</span>
					        		</div> : null
					        }
					        {
					        	verifyResults[i].currentSignatureFormat ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:signatureFormat")}</span><span>{ i18next.t("ds:" + verifyResults[i].currentSignatureFormat) }</span>
					        		</div> : null
					        }
	        			</div>
	        			: <div>
		        			{
					        	verifyResults[i].previousSignatureFormat ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:previousSignatureFormat")}</span><span>{ i18next.t("ds:" + verifyResults[i].previousSignatureFormat) }</span>
					        		</div> : null
					        }
					        {
					        	verifyResults[i].currentSignatureFormat ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:currentSignatureFormat")}</span><span>{ i18next.t("ds:" + verifyResults[i].currentSignatureFormat) }</span>
					        		</div> : null
					        }

					        {
					        	verifyResults[i].previousSignatureType ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:previousSignatureType")}</span><span>{ i18next.t("ds:" + verifyResults[i].previousSignatureType) }</span>
					        		</div> : null
					        }
					        {
					        	verifyResults[i].currentSignatureType ?
					        		<div>
					    				<span className="font-weight-bold">{ i18next.t("ds:currentSignatureType")}</span><span>{ i18next.t("ds:" + verifyResults[i].currentSignatureType) }</span>
					        		</div> : null
					        }
					    </div>
	        		}
	        		{
	        			verifyResults[i].failureCause !== null && verifyResults[i].failureCause !== undefined && verifyResults[i].failureCause.length > 0
	        			? <div style={{paddingTop: "10px"}}><span className="font-weight-bold">{verifyResults[i].failureCause}</span></div>
	        			: null
	        		}
	        		
	    		</div>)

	        	divPtblg.push(<div className="ptblg-default" style={{marginLeft: "-10px", marginRight: "-10px", marginTop: "-10px"}}>
	        		{
						 <div className={(verifyResults[i].status === "SUCCESS") ? "alert alert-success" : "alert alert-warning"}>
			        		<div className="row">
			        			<div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 no-left-right-padding" style={{paddingLeft: "11px"}}>{signerNumber} {signerStatus}</div> <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12 no-left-no-right-padding">{signerDetails}</div>
			        		</div>
			        	</div>
			        }
	        	</div>)
			}
		}


		if (!this.props.defaultOptionState.showUpgradeCard) {
			if (isNested) {
	        	rootDiv.push(<div id="divPtblg">{
	        		<TreeView data={tree} />
	        	}</div>)
	        } else {
	        	generateVerifyResultsViewSimple(verifyResults)
	        	rootDiv.push(<div id="divPtblg">{divPtblg}</div>)
	        }
		} else {
			generateModifyResults(_this.props.defaultState.differenceSignatureType)
	        rootDiv.push(<div id="divPtblg">{divPtblg}</div>)
		}
          
        return rootDiv

    }

	render () {
		const isEnabled = this.props.defaultOptionState.signatureType === 'detached' ?
				this.props.defaultState.fileInputSelected && this.props.defaultState.fileWithDSSelected
				: this.props.defaultState.fileWithDSSelected;

		const isEnabledDownload = this.props.defaultState.fileSignedData ? true : false;

		const isEnabledDownloadModifiedDS = this.props.upgradeReducer.modifiedDSData ? true : false;

		return (
			<div>
	            <div className="row" style={{paddingTop: "10px"}}>
	            <VerifyDSOptionsContainer />
	              <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
	                <div className="card">
	                  <div className="card-header" onClick={this.expandVerifyDS.bind(this)} role="button">
	                    {
							this.props.expandedCardsReducer.verifyExpanded ? <i className="fa fa-chevron-down" aria-hidden="true" style={{"cursor": "pointer"}}></i>
								: <i className="fa fa-chevron-up" aria-hidden="true" style={{"cursor": "pointer"}}></i>
						}&nbsp;{i18next.t("file")}
	                  </div>
	                  <div className={this.state.collapseVerifyDSShow} data-toggle="collapse" aria-expanded={this.props.expandedCardsReducer.verifyExpanded}>
	                    <div>
	                    	{
	                    		this.props.defaultOptionState.signatureType === 'detached'
	                    		? <div className="no-left-right-padding">
	                    			<label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 col-form-label no-left-right-padding">{i18next.t("ds:fileForVerifyingTitle")}</label>
	                                <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 no-left-right-padding">
		                                {
		                                  this.props.mobileModeReducer.mobileDeviceMode
		                                  ? 
		                                  <div className="input-group row" style={{marginLeft: "0px"}}>
		                                    <input type="text" className="form-control col-lg-8 col-md-8 col-xs-12 col-sm-12"  value={this.props.defaultState.fileInputName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileInputSelect.bind(this)} readOnly />
		                                    {
												this.props.defaultState.fileInputSelected
												? <button className="btn btn-default col-lg-4 col-md-4 col-xs-12 col-sm-12 margin-top-sm" style={{"cursor": "pointer"}} onClick={this.handleFileInputSelect.bind(this)}>{i18next.t("changeFile")}</button>
												: <button className="btn btn-default col-lg-4 col-md-4 col-xs-12 col-sm-12 margin-top-sm" style={{"cursor": "pointer"}} onClick={this.handleFileInputSelect.bind(this)}>{i18next.t("chooseFile")}</button>
											}

		                                  </div>
		                                  : <div>
		                                  		{
		                                  			this.props.defaultState.fileInputSelected
		                                  			? <div className="input-group mb-4">
														<input type="text" className="form-control" value={this.props.defaultState.fileInputName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileInputSelect.bind(this)} readOnly />
														<div className="input-group-append">
													      	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.cleanUpFileInputSelect.bind(this)}>{i18next.t("cleanup")}</button>
													    </div>
													</div>
								                    : <Dropzone ref={dropzoneRef} onDrop={this.handleOnDrop} multiple={false}>
								                        {({getRootProps, getInputProps}) => (
								                            <div {...getRootProps()} style={{cursor: "pointer"}} className="dropzone" id="dropFile">
								                                <input {...getInputProps()} />
								                                <p style={{cursor: "pointer", marginTop: "16px"}}>{i18next.t("dragNDropTitleSecond")}</p>
								                            </div>
								                        )}
								                    </Dropzone>
		                                  		}
											</div>
		                                }
	                                </div>
	                                <input id="fileInputUpload" type="file" onChange={this.onChangeInput.bind(this)} style={{"display": "none"}} />
	                            </div>
								: <input id="fileInputUpload" type="file" onChange={this.onChangeInput.bind(this)} style={{"display": "none"}} />
	                    	}

	                    	<div className="no-left-right-padding" style={{marginBottom: "10px"}}>
                    			<label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 col-form-label no-left-right-padding">{i18next.t("ds:fileWithDsTitle")}</label>
                                <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 no-left-right-padding">
	                                {
	                                  this.props.mobileModeReducer.mobileDeviceMode
	                                  ? 
	                                  <div className="input-group row" style={{marginLeft: "0px"}}>
	                                    <input type="text" className="form-control col-lg-8 col-md-8 col-xs-12 col-sm-12"  value={this.props.defaultState.fileWithDSName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileWithDSSelect.bind(this)} readOnly />
	                                    {
											this.props.defaultState.fileWithDSSelected
											? <button className="btn btn-default col-lg-4 col-md-4 col-xs-12 col-sm-12 margin-top-sm" style={{"cursor": "pointer"}} onClick={this.handleFileWithDSSelect.bind(this)}>{i18next.t("changeFile")}</button>
											: <button className="btn btn-default col-lg-4 col-md-4 col-xs-12 col-sm-12 margin-top-sm" style={{"cursor": "pointer"}} onClick={this.handleFileWithDSSelect.bind(this)}>{i18next.t("chooseFile")}</button>
										}
	                                    </div>
	                                    : <div>
	                                    	{
	                                    		this.props.defaultState.fileWithDSSelected
	                                    		? <div className="input-group mb-4">
													<input type="text" className="form-control" value={this.props.defaultState.fileWithDSName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileWithDSSelect.bind(this)} readOnly />
													<div className="input-group-append">
												      	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.cleanUpFileWithDSSelect.bind(this)}>{i18next.t("cleanup")}</button>
												    </div>
												</div>
												: <Dropzone ref={dropzoneDSRef} onDrop={this.handleOnDropDS} multiple={false}>
							                        {({getRootProps, getInputProps}) => (
							                            <div {...getRootProps()} style={{cursor: "pointer"}} className="dropzone" id="dropDS">
							                                <input {...getInputProps()} />
							                                <p style={{cursor: "pointer", marginTop: "16px"}}>{i18next.t("dragNDropTitleSecond")}</p>
							                            </div>
							                        )}
							                    </Dropzone>
	                                    	}
	                                      </div>
	                                    
	                                }
                                </div>
                                <input id="fileWithDSUpload" type="file" onChange={this.onChangeDS.bind(this)} style={{"display": "none"}} />
                            </div>
                            {
                            	(!this.props.base.isLoading && this.props.defaultState.verifyResults !== null && this.props.defaultState.verifyResults.length > 0 && !this.props.defaultOptionState.showUpgradeCard)
                            	? <div className="row" style={{marginLeft: "0px", marginRight: "0px"}}>
                            		<div className="col-6 no-left-no-right-padding" style={{textAlign: "left", marginTop: "-10px", marginBottom: "10px"}}>
		                            	{
		                            		this.props.base.pdfReportEnabled === "true"
		                            		? <span style={{cursor: "pointer", color: "#1a0dab", textAlign: "left"}} onClick={this.saveVerifyResultsToPdf}>{i18next.t("inspectionReport")}</span>
		                            		: null
		                            	}
		                        	</div>
                            		<div className="col-6 no-left-no-right-padding" style={{textAlign: "right", marginTop: "-10px", marginBottom: "10px"}}>
		                            	<span id="copyLink" style={{cursor: "pointer", color: "#1a0dab", textAlign: "right"}} onClick={this.copyVerifyResults}>{i18next.t("copyVerifyDSResultToClipboardTitle")}</span>
		                        	</div>
		                        </div>
                            	: null
                            }

                            {
                            	this.props.defaultOptionState.generateQR
                            	? (!this.props.base.isLoading && this.props.defaultState.verifyResults && this.props.defaultState.verifyResultsForQR) ? this.showDsVerifyResults(this.props.defaultState.verifyResults, this.props.defaultState.divId) : null
                            	: (!this.props.base.isLoading && this.props.defaultState.verifyResults) ? this.showDsVerifyResults(this.props.defaultState.verifyResults, this.props.defaultState.divId) : null
                            }

							<div className="row">
								<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 order-0 order-md-4">
			                        <button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom: "10px"}} onClick={this.setInputState.bind(this)} disabled={!isEnabled}>{this.props.defaultOptionState.showUpgradeCard ? i18next.t("ds:modifyDs") : i18next.t("ds:verifyDs")}
			                        	{
			                              	this.props.base.isLoading ? <span>&nbsp;<i className="fa fa-spinner fa-pulse"></i></span>
			                                : null
			                            }
			                        </button>
		                        </div>
		                        {
		                        	this.props.defaultOptionState.signatureType === 'attached' && !this.props.defaultOptionState.showUpgradeCard
		                        	? <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 order-1 row no-left-no-right-padding" style={{"marginLeft": "0px", "marginRight": "0px"}}>
		                        		<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12"><button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom: "10px"}} disabled={!isEnabledDownload} onClick={this.downloadSignedData.bind(this)}>{i18next.t("ds:saveSignedData")}</button></div>
		                        	</div>
		                        	: null
		                        }
		                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 order-2 order-md-6 no-left-padding">
		                        	<button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom: "10px"}} onClick={this.cleanUpForm.bind(this)}>{i18next.t("cleanUpForm")}</button>
		                        </div>
	                        </div>
	                        <div className="row">
	                        	{
		                        	this.props.defaultOptionState.showUpgradeCard && (this.props.defaultState.differenceSignatureType !== null && this.props.defaultState.differenceSignatureType[0] !== undefined && this.props.defaultState.differenceSignatureType[0].previousSignatureFormat !== "CADES_X_LONG")
		                        	? <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
		                        		<button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" disabled={!isEnabledDownloadModifiedDS} onClick={this.downloadModifiedData.bind(this)}>{i18next.t("ds:downloadModifiedDataTitle")}</button>
		                        	</div>
		                        	: null
		                        }
		                    </div>
		                    <div className="row">
	                        	{
		                        	this.props.defaultOptionState.showUpgradeCard && (this.props.defaultState.differenceSignatureType !== null && this.props.defaultState.differenceSignatureType[0] !== undefined && this.props.defaultState.differenceSignatureType[0].previousSignatureFormat !== "CADES_X_LONG")
		                        	? <div style={{marginTop: "10px"}} className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
		                        		<button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" disabled={!isEnabledDownloadModifiedDS} onClick={this.verifyModifiedData.bind(this)}>{i18next.t("ds:verifyModifiedDataTitle")}</button>
		                        	</div>
		                        	: null
		                        }
		                    </div>
	                    </div>
	                    </div>
	                   </div>
	                   <VerifyTextDSContainer />
	                </div>
	                <div>
	                    {
	                        this.state.showPopup
	                        ? <QRPopup closeQRPopup={this.handleShowQR} data={this.state.displayedData} />
	                        : null
	                    }
	                    {
	                        this.state.showPrivateSignPopup
	                        ? <PrivateSignPopup closePrivateSignPopup={this.handleShowPrivateSign} data={this.state.displayedData} />
	                        : null
	                    }
	                </div>
	            </div>
	        </div>
		);
	}
}

function mapStateToProps(state) {
    return {
    	base: state.base,
        language: state.localesReducer.language,
        localesReducer: state.localesReducer,
        defaultState: state.verifyDSInputReducer,
        defaultOptionState: state.verifyDSOptionsReducer,
        mobileModeReducer: state.mobileModeReducer,
        expandedCardsReducer: state.expandedCardsReducer,
        upgradeReducer: state.upgradeDSReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
    	setVerifyInputFile,
    	setVerifyDSInputFile,
    	clearVerifyInputFile,
    	clearVerifyDSInputFile,
    	clearVerifyResultData,
    	clearFileSignedData,
    	setVerifyDSExpand,
    	clearModifiedDSData,
    	setIsLoading,
    	setSignatureDifferenceType,
    	clearSignatureDifferenceType,
    	fromBytes, setShowUpgradeCard
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(VerifyDSTab);